var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_4813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30347 11.576C7.51878 11.576 6.84378 12.356 6.79691 13.3723C6.75003 14.3885 7.43722 14.802 8.22285 14.802C9.00847 14.802 9.59441 14.4326 9.64128 13.4163C9.68816 12.4001 9.08816 11.576 8.30347 11.576Z",
    fill: "#282B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2153 13.3723C17.1694 12.356 16.4944 11.576 15.7088 11.576C14.9232 11.576 14.3241 12.4001 14.371 13.4163C14.4178 14.4335 15.0047 14.802 15.7894 14.802C16.5741 14.802 17.2622 14.3885 17.2153 13.3723Z",
    fill: "#282B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9588 16.0282C15.016 15.8913 14.9222 15.7385 14.775 15.7235C13.9116 15.6363 12.9797 15.5885 12.0057 15.5885C11.0316 15.5885 10.0988 15.6363 9.23628 15.7235C9.0891 15.7385 8.99535 15.8913 9.05253 16.0282C9.53628 17.1823 10.6753 17.9932 12.0057 17.9932C13.336 17.9932 14.476 17.1823 14.9588 16.0282Z",
    fill: "#282B59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0007C0 5.37354 5.37281 0.000732422 12 0.000732422C18.6272 0.000732422 24 5.37354 24 12.0007C24 18.6279 18.6272 24.0007 12 24.0007H1.73813C1.09688 24.0007 0.775312 23.2254 1.22906 22.7717L3.51469 20.486C1.34344 18.3148 0 15.3148 0 12.0007ZM16.3875 7.19884C15.4416 7.19884 14.6494 6.54165 14.4413 5.65946V5.66134C13.2938 5.82353 12.4088 6.81165 12.4088 8.00228V8.00978C14.1853 8.07634 15.8091 8.57696 17.0953 9.3729C17.5678 9.00915 18.1594 8.79259 18.8016 8.79259C20.3494 8.79259 21.6038 10.047 21.6038 11.5948C21.6038 12.7113 20.9494 13.676 20.0035 14.126C19.9153 17.382 16.366 20.0013 12.0057 20.0013C7.64535 20.0013 4.10066 17.3848 4.00785 14.1317C3.05441 13.6845 2.39441 12.717 2.39441 11.5938C2.39441 10.046 3.64878 8.79165 5.1966 8.79165C5.8416 8.79165 6.43597 9.01009 6.90941 9.37665C8.18441 8.58634 9.79035 8.08571 11.5491 8.01165V8.00134C11.5491 6.33915 12.8119 4.96759 14.4291 4.79415C14.6166 3.88384 15.4219 3.19946 16.3875 3.19946C17.4919 3.19946 18.3872 4.09478 18.3872 5.19915C18.3872 6.30353 17.4919 7.19884 16.3875 7.19884Z",
    fill: "#282B59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_4813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.317970102d55825327701868679fe0fd.svg";
export { ForwardRef as ReactComponent };